import { useState } from "react";
import { RefreshCw, X } from "lucide-react";
import { Button } from "./ui/button";
import { useI18n } from "../lib/i18n";
import { useAppUpdate } from "../lib/appVersion";

const UpdateBanner = () => {
  const { t } = useI18n();
  const { updateAvailable, reload } = useAppUpdate();
  const [dismissed, setDismissed] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!updateAvailable || dismissed) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[70] flex justify-center px-3 pt-[max(0.5rem,env(safe-area-inset-top))] pointer-events-none" data-testid="update-banner">
      <div className="pointer-events-auto flex items-center gap-3 rounded-full bg-primary text-primary-foreground shadow-lg px-4 py-2 text-sm">
        <RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} />
        <span>{t("app.update_available")}</span>
        <Button size="sm" variant="secondary" className="h-7 rounded-full px-3" onClick={() => { setBusy(true); reload(); }} data-testid="update-banner-reload-btn">{t("app.refresh_now")}</Button>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Fermer" className="opacity-80 hover:opacity-100" data-testid="update-banner-close-btn"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};

export default UpdateBanner;
